export default __webpack_public_path__ + "static/media/cp_geo_pw.5948ddc6.svg";